export default "__VITE_ASSET__540a779c__"